<template>
  <div class="file-list">
    <h3>{{ title }}</h3>
    <p class="file-date">{{ date }}</p>
    <div class="file-content">
      <slot></slot>
    </div>
    
    <!-- 分页 -->
    <div class="pagination" v-if="showPagination">
      <span>&lt;</span>
      <span class="page active">1</span>
      <span class="page">2</span>
      <span class="page">3</span>
      <span class="page">4</span>
      <span>&gt;</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileList',
  props: {
    title: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    showPagination: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.file-list h3 {
  color: #0066cc;
  font-size: 20px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid #0066cc;
}

.file-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.file-content {
  line-height: 1.8;
}

.file-content h4 {
  color: #333;
  font-size: 16px;
  margin: 20px 0 10px;
}

.file-content p {
  margin-bottom: 15px;
}

.file-content ol {
  margin-left: 20px;
  margin-bottom: 15px;
}

.file-content li {
  margin-bottom: 8px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  gap: 8px;
}

.pagination span {
  padding: 8px 12px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: all 0.3s;
}

.pagination span:hover {
  border-color: #0066cc;
  color: #0066cc;
}

.pagination .page.active {
  background-color: #0066cc;
  color: white;
  border-color: #0066cc;
}
</style>